import * as validation from '@/utils/validation';
import * as DateTime from '@/utils/date';
import * as liveServices from '@/services/liveServices';

export default {
  data() {
    return {
      startAt: null,
      endAt: null,
      reserveStartAt: null,
      reserveEndAt: null,
      title: null,
      imageFile: null,
      previewImageUrl: null
    };
  },
  watch: {
    title: function() {
      this.title = validation.charaLimit(this.title, 30);
    }
  },
  computed: {
    allowScheduleInput() {
      return !this.reserveStartAt && !this.reserveEndAt;
    },
    allowReserveInput() {
      return this.startAt && this.endAt;
    }
  },
  methods: {
    async validate() {
      DateTime.trimJSSeconds(this.startAt);
      DateTime.trimJSSeconds(this.endAt);
      DateTime.trimJSSeconds(this.reserveStartAt);
      DateTime.trimJSSeconds(this.reserveEndAt);

      let errorMessage = await this.check();

      if (errorMessage) {
        this.$buefy.toast.open({
          duration: 3000,
          message: errorMessage,
          type: 'is-danger'
        });
        return false;
      }

      return true;
    },
    async check() {
      if (!this.startAt || !this.endAt || (this.reserveStartAt && !this.reserveEndAt) || (!this.reserveStartAt && this.reserveEndAt) || !this.previewImageUrl || !this.title) {
        return "すべての項目を入れてください";
      }

      if (this.startAt >= this.endAt) {
        return "配信終了日時に配信開始日時以前の日時が設定されています。";
      }
      if (this.reserveStartAt && this.reserveEndAt && this.reserveStartAt >= this.reserveEndAt) {
        return "限定配信終了日時に限定配信開始日時以前の日時が設定されています。";
      }
      if (this.reserveStartAt && this.startAt > this.reserveStartAt) {
        return "限定配信開始日時に配信開始日時より前の日付が設定されています。";
      }
      if (this.reserveEndAt && this.reserveEndAt > this.endAt) {
        return "限定配信終了日時に配信終了日時より後の日付が設定されています。";
      }

      var now = (await DateTime.serverDate()).toJSDate();

      if (now >= this.endAt) {
        return "配信終了日時に現在日時以前の日時が設定されています。";
      }

      let checkScheduleDuplicationResult = await this.checkScheduleDuplication();
      if (!checkScheduleDuplicationResult) {
        return "配信期間が重複しています。";
      }

      if (!validation.checkNGWord(this.title)) {
        return "タイトルに不適切な表現が含まれています。";
      }

      return null;
    },
    async checkScheduleDuplication() {
      let liveId = this.values ? this.values.liveId : null;
      let uid = this.$store.state.auth.uid;

      let recentLives = await liveServices.getRecentLivesByPerformerId(uid, 100);
      if (recentLives) {
        for (const doc of recentLives) {
          if (this.checkDateDuplication(doc.startAt, doc.upComingEndAt)) {
            return false;
          }
        }
      }

      let upComingLives = await liveServices.getUpcomingLivesByPerformerId(uid, 1000);
      if (upComingLives) {
        for (const doc of upComingLives) {
          if (liveId && liveId == doc.id) {
            continue;
          }
          if (this.checkDateDuplication(doc.startAt, doc.endAt)) {
            return false;
          }
        }
      }

      return true;
    },
    checkDateDuplication(startAt, endAt) {
      return startAt < this.endAt && endAt > this.startAt;
    }
  }
}
